import { announcementBannerSettingsV4Resource } from '@jira/admin-pages__system-announcement-banner-resources/src/useAnnouncementBannerSettingsV4Resource.tsx';
import { assetsReportingConfigResource } from '@jira/router-resources__assets-reports/src/index.tsx';
import { assetsUserPermissionResource } from '@atlassian/jira-router-resources-assets-user-permission/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { getNavigationResources } from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import { resourceWithCondition2 } from '@atlassian/jira-router-resources-utils/src/utils/resource-with-condition/index.tsx';
import { getServicedeskPageContextResources } from '@atlassian/jira-router-resources-service-desk-common/src/index.tsx';
import { getConsentBannerUserPreferencesResource } from '@atlassian/jira-router-resources-cookie-consent/src/index.tsx';
import { workspaceResource } from '@atlassian/jira-servicedesk-insight-common-workspace-context/src/services/resources/index.tsx';
import { jiraSpaResources } from '@atlassian/jira-router-resources-spa-page-container/src/index.tsx';
import { rovoEntitlementResource } from '@atlassian/jira-router-resources-rovo-entitlement/src/services/index.tsx';
import {
	assetsBannerSettingsResource,
	assetsLogoAndFaviconResource,
	assetsNavigationSettingsResource,
} from '@atlassian/jira-router-resources-assets-admin-settings/src/index.tsx';

export function getCmdbResources() {
	return [...getNavigationResources(), ...getServicedeskPageContextResources(), workspaceResource];
}

export function getAssetsAppResources() {
	return [
		...jiraSpaResources(),
		workspaceResource,
		resourceWithCondition2(() => fg('aurum-997-license-kill-switch'), assetsUserPermissionResource),
		resourceWithCondition2(
			() => fg('assets-announcement-banner-settings'),
			assetsNavigationSettingsResource,
		),
		resourceWithCondition2(
			() => fg('assets-announcement-banner-settings'),
			assetsBannerSettingsResource,
		),
		resourceWithCondition2(
			() => fg('assets-announcement-banner-settings'),
			assetsLogoAndFaviconResource,
		),
		rovoEntitlementResource,
		getConsentBannerUserPreferencesResource(),
		resourceWithCondition2(
			() => fg('show_announcement_banner_in_assets'),
			announcementBannerSettingsV4Resource,
		),
		assetsReportingConfigResource,
	];
}
